/**
 * Nom AFFICHÉ de la marketplace dans le backoffice OPS.
 *
 * Depuis le 03/11/2026 la marketplace (artisans, particuliers, projets, leads,
 * crédits, litiges, avis, parrainages, acquisition d'artisans) s'appelle
 * Bricko : app.bricko.fr, site bricko.fr, API api.bricko.fr.
 *
 * Les identifiants TECHNIQUES restent « TRAVAUXBTP » / « travauxbtp » : enums
 * Prisma (`App.TRAVAUXBTP`, `SalesLeadSource.TRAVAUX_BTP`…), clés de page RBAC
 * (`TRAVAUXBTP_DASHBOARD`, `TRAVAUXBTP_REFERRALS`), routes tRPC
 * (`admin.travauxbtp.*`), chemins d'URL OPS (`/travauxbtp/...`). Seul le
 * libellé affiché passe par ce module.
 *
 * ⚠️ travauxbtp.fr continue d'exister comme site de CONTENU (blog) indépendant :
 * dans les modules SEO, Contenu et Netlinking, « TravauxBTP » désigne ce site
 * et ne doit PAS être remplacé par cette constante.
 */
export const MARKETPLACE_LABEL = "Bricko";
